module.exports = __webpack_public_path__ + "img/jzf.e5b1d798.png";